import { fixLineBreaks } from './vttparser';
import DetectBrowser from '../../utils/detectBrowser';
import semver from 'semver';

const Cues = {

	newCue: function (track, startTime, endTime, captionScreen) {
		let myEndTime = endTime;
		var row;
		var cue;
		var indenting;
		var indent;
		var text;
		var VTTCue = window.VTTCue || window.TextTrackCue;
		var browDetected = DetectBrowser; //Mactrix line added, improved browser detection --Ideally we'd pass this in; I'll try to improve this later - SIEG

		for (var r = 0; r < captionScreen.rows.length; r++) {
			row = captionScreen.rows[r];
			indenting = true;
			indent = 0;
			text = '';

			if (!row.isEmpty()) {
				for (var c = 0; c < row.chars.length; c++) {
					if (row.chars[c].uchar.match(/\s/) && indenting) {
						indent++;
					}
					else {
						text += row.chars[c].uchar;
						indenting = false;
					}
				}
		//To be used for cleaning-up orphaned roll-up captions
				row.cueStartTime = startTime;

		// Give a slight bump to the myEndTime if it's equal to startTime to avoid a SyntaxError in IE
				if (startTime === myEndTime) {
					myEndTime += 0.0001;
				}

//Mactrix changes begin: new VTTCue can throw, for example, startTime is NaN
				try {
//Mactrix changes end
					cue = new VTTCue(startTime, myEndTime, fixLineBreaks(text.trim()));

					if (indent >= 16) {
						indent--;
					}
					else {
						indent++;
					}

					// VTTCue.line get's flakey when using controls, so let's now include line 13&14
					// also, drop line 1 since it's to close to the top
					if (browDetected.name === 'firefox') {
						cue.line = r + 1;
					}
					else {
						cue.line = (r > 7 ? r - 2 : r + 1);
					}
		/*
		cue.align = 'left';
		*/
		//Mactrix changes start
		//this line throws a syntax error in Tizen 2.3
					if (browDetected.name !== 'tizen' || !semver.satisfies(browDetected.version, '2.x.x')) {
						cue.align = 'left';

						// Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
						//Tizen 2.3 doesn't seem to like this either, captions get bunched up on the left side of the video with this enabled
						cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + ((browDetected.name === 'firefox') ? 50 : 0)));
					}
				}
				catch (err) {
					//logger.warn(err + ' StartTime: ' + startTime + ', EndTime: ' + myEndTime);
				}
//Mactrix changes end

/* mactrix replace
		track.addCue(cue);
*/
				try {
					track.addCue(cue); //Mactrix above line changed, added try/catch
				}
				catch(err) {
				}
			}
		}
	},

};

module.exports = Cues;



// WEBPACK FOOTER //
// ./src/hlsjs/utils/cues.js